import SnapType from './snapType';
import LineOrientation from './lineOrientation';

export default class BaseCanvasPositioningHelper {
  constructor() {}

  getNodeSnappingEdges(node) {
    const box = node.getClientRect();
    const absolutePosition = node.absolutePosition();

    return {
      vertical: [
        {
          line: Math.round(box.x),
          offset: Math.round(absolutePosition.x - box.x),
          snap: SnapType.Start
        },
        {
          line: Math.round(box.x + box.width / 2),
          offset: Math.round(absolutePosition.x - box.x - box.width / 2),
          snap: SnapType.Center
        },
        {
          line: Math.round(box.x + box.width),
          offset: Math.round(absolutePosition.x - box.x - box.width),
          snap: SnapType.End
        },
      ],
      horizontal: [
        {
          line: Math.round(box.y),
          offset: Math.round(absolutePosition.y - box.y),
          snap: SnapType.Start
        },
        {
          line: Math.round(box.y + box.height / 2),
          offset: Math.round(absolutePosition.y - box.y - box.height / 2),
          snap: SnapType.Center
        },
        {
          line: Math.round(box.y + box.height),
          offset: Math.round(absolutePosition.y - box.y - box.height),
          snap: SnapType.End
        },
      ]
    };
  };

  getClosestAlignmentLines(possibleAlignmentLines, nodeBounds, minimalStepSize) {
    const verticalResult = [];
    const horizontalResult = [];

    possibleAlignmentLines.vertical.forEach(line => {
      nodeBounds.vertical.forEach(bound => {
        const difference = Math.abs(line - bound.line);

        if (difference < minimalStepSize) {
          verticalResult.push({
            line: line,
            difference: difference,
            snap: bound.snap,
            offset: bound.offset
          });
        }
      });
    });

    possibleAlignmentLines.vertical.forEach(line => {
      const centralLine = nodeBounds.vertical[1];
      const difference = Math.abs(line - centralLine.line);

      if (difference < minimalStepSize * 2) {
        const baseLine = line;

        possibleAlignmentLines.vertical.forEach(nextLine => {
          if (nextLine > baseLine) {
            const centre = (nextLine - baseLine) / 2;

            verticalResult.push({
              line: baseLine + centre,
              difference: difference,
              snap: centralLine.snap,
              offset: centralLine.offset
            });

            return;
          }
        })
      }
    });

    possibleAlignmentLines.horizontal.forEach(line => {
      nodeBounds.horizontal.forEach(bound => {
        const difference = Math.abs(line - bound.line);

        if (difference < minimalStepSize) {
          horizontalResult.push({
            line: line,
            difference: difference,
            snap: bound.snap,
            offset: bound.offset
          });
        }
      });
    });

    var lines = [];

    const verticalClosestSnap = verticalResult.sort((a, b) => a.difference - b.difference)[0];
    const horizontalClosestSnap = horizontalResult.sort((a, b) => a.difference - b.difference)[0];

    if (!!verticalClosestSnap) {
      lines.push({
        line: verticalClosestSnap.line,
        offset: verticalClosestSnap.offset,
        orientation: LineOrientation.Vertical,
        snap: verticalClosestSnap.snap
      });
    }

    if (!!horizontalClosestSnap) {
      lines.push({
        line: horizontalClosestSnap.line,
        offset: horizontalClosestSnap.offset,
        orientation: LineOrientation.Horizontal,
        snap: horizontalClosestSnap.snap
      });
    }

    return lines;
  }
}